import React from "react";

const LumiereIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    {...props}
  >
    <rect x="1.5" y="8" width="3" height="8" rx="1.5" />
    <rect x="6" y="4" width="3" height="16" rx="1.5" />
    <rect x="10.5" y="6" width="3" height="12" rx="1.5" />
    <rect x="15" y="4" width="3" height="16" rx="1.5" />
    <rect x="19.5" y="8" width="3" height="8" rx="1.5" />
  </svg>
);

export default LumiereIcon;
